/**
 * Lead Factory task and owned-property complete actions.
 */
import { formatInteger } from "./format.js";
import { authenticatedFetch } from "./dashboard-auth.js";
import type { DashboardActionHost } from "./dashboard-referenced-deed-actions.js";

export async function submitTaskComplete(
  taskId: string,
  statusElement: HTMLElement,
  actions: DashboardActionHost
): Promise<void> {
  statusElement.textContent = `Completing ${taskId}...`;
  try {
    const response = await authenticatedFetch(`/dashboard/lead-factory/tasks/${encodeURIComponent(taskId)}/complete`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ note: "Completed from Lead Factory dashboard." })
    });
    const body = (await response.json()) as { error?: string };
    if (!response.ok) throw new Error(body.error ?? `Request failed with ${response.status}`);
    statusElement.textContent = `${taskId}: completed. Refreshing...`;
    setTimeout(() => actions.refresh(), 650);
  } catch (error) {
    statusElement.textContent = error instanceof Error ? error.message : "Task completion failed.";
  }
}

export async function submitOwnedPropertyTaskComplete(
  taskId: string,
  statusElement: HTMLElement,
  actions: DashboardActionHost
): Promise<void> {
  statusElement.textContent = `Completing ${taskId}...`;
  try {
    const response = await authenticatedFetch(`/dashboard/lead-factory/owned-property-tasks/${encodeURIComponent(taskId)}/complete`, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ note: "Completed from Lead Factory dashboard." })
    });
    const body = (await response.json()) as { error?: string };
    if (!response.ok) throw new Error(body.error ?? `Request failed with ${response.status}`);
    statusElement.textContent = `${taskId}: completed. Refreshing...`;
    setTimeout(() => actions.refresh(), 650);
  } catch (error) {
    statusElement.textContent = error instanceof Error ? error.message : "Asset task completion failed.";
  }
}

export async function submitOwnedPropertyBulkComplete(
  taskIds: string[],
  leadId: string,
  statusElement: HTMLElement,
  actions: DashboardActionHost
): Promise<void> {
  statusElement.textContent = `Completing ${formatInteger(taskIds.length)} asset task(s) for ${leadId}...`;
  try {
    let completed = 0;
    for (const taskId of taskIds) {
      const response = await authenticatedFetch(`/dashboard/lead-factory/owned-property-tasks/${encodeURIComponent(taskId)}/complete`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ note: "Bulk completed from Asset Work dashboard." })
      });
      const body = (await response.json()) as { error?: string };
      if (!response.ok) throw new Error(body.error ?? `Request failed with ${response.status}`);
      completed += 1;
    }
    statusElement.textContent = `${leadId}: completed ${formatInteger(completed)} asset task(s). Refreshing...`;
    setTimeout(() => actions.refresh(), 650);
  } catch (error) {
    statusElement.textContent = error instanceof Error ? error.message : "Asset task bulk completion failed.";
  }
}
